import { lazy, Suspense } from 'react';
import { Route, Routes as _Routes, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import BouncingLoader from '~/shared/components/ds/BouncingLoader';
import MainFlowLayout from '~/shared/components/ds/MainFlowLlayout';
import Zendesk from '~/zendesk'; // resize for auth screen not working with `lazy(() => import('~/zendesk'));`
import RedirectWithParams from '~/shared/components/ds/RedirectWithParams.tsx';
import NotFound from '~/shared/components/ds/NotFound.tsx';

import AuthenticatedOutlet from './AuthenticatedOutlet';

const Salesforce = lazy(() => import('~/salesforce'));
const Iframe = lazy(() => import('~/iframe'));
const AnonIframe = lazy(() => import('~/anonIframe'));
const JwtIframe = lazy(() => import('~/jwtIframe'));

const Loading = () => (
  <MainFlowLayout>
    <BouncingLoader />
  </MainFlowLayout>
);

const NON_AUTH0_ROUTES = ['anon-iframe', 'jwt-iframe'];

function isNonAuth0Route(pathname: string): boolean {
  return NON_AUTH0_ROUTES.some((route) => pathname.includes(route));
}

export default function Routes() {
  const location = useLocation();
  const { isLoading } = useAuth0();

  const shouldWaitForAuth0 = !isNonAuth0Route(location.pathname);

  if (shouldWaitForAuth0 && isLoading) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <_Routes>
        {/* Non-Auth0 routes - don't require Auth0 authentication */}
        <Route path="anon-iframe" element={<AnonIframe />} />
        <Route path="jwt-iframe" element={<JwtIframe />} />

        <Route path="/" Component={() => <AuthenticatedOutlet />}>
          <Route path="zendesk" element={<Zendesk />} />
          <Route path="salesforce" element={<Salesforce />} />
          <Route path="iframe" element={<Iframe />} />
          {/* required for manual sign-in selection from header menu items */}
          <Route path="sign-in" element={<RedirectWithParams to="iframe" />} />
        </Route>
        <Route path="/*" Component={() => <NotFound />} />
      </_Routes>
    </Suspense>
  );
}
